import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'

import SingleOption from './single-option'

interface CalculatorCurrencySelectProps {
  isBaseCurrencyComponent: boolean
  baseCurrency: string
  counterCurrency: string
  handleSetbaseCurrency: (value: string) => void
  handleSetcounterCurrency: (value: string) => void
  fixedCurrencyList: string[]
  isDarkMode?: boolean
}

const CalculatorCurrencySelect = ({
  isBaseCurrencyComponent,
  baseCurrency,
  counterCurrency,
  handleSetbaseCurrency,
  handleSetcounterCurrency,
  fixedCurrencyList,
  isDarkMode,
}: CalculatorCurrencySelectProps) => {
  const [isSelectVisible, setSelectVisibility] = useState(false)

  const toggleSelectVisibility = (): void => {
    setSelectVisibility((prev) => !prev)
  }

  const selectedCurrency = isBaseCurrencyComponent ? baseCurrency : counterCurrency
  const componentName = isBaseCurrencyComponent ? 'base' : 'counter'

  const disableOptionsList = (e: MouseEvent) => {
    const target = e.target as HTMLElement
    const holder = document.querySelector<HTMLDivElement>(`[data-currency-holder=${componentName}]`)
    const isInside = target.closest(`[data-calculator-currency=${componentName}]`)
    const shouldCloseSelect = isSelectVisible && holder && !isInside && !holder.contains(target)

    if (shouldCloseSelect) {
      setSelectVisibility(false)
    }
  }

  useEffect(() => {
    const listener = (e: MouseEvent) => disableOptionsList(e)
    const main = document.querySelector<HTMLDivElement>('.calc-widget__main')
    main?.addEventListener('click', listener)
    return () => main?.removeEventListener('click', listener)
  }, [isSelectVisible, componentName])

  const setSelectedCurrency = (selectedOption: string): void => {
    if (isBaseCurrencyComponent) {
      handleSetbaseCurrency(selectedOption)
      if (selectedOption === counterCurrency) {
        handleSetcounterCurrency(baseCurrency)
      }
    } else {
      handleSetcounterCurrency(selectedOption)
      if (selectedOption === baseCurrency) {
        handleSetbaseCurrency(counterCurrency)
      }
    }
  }

  return (
    <div
      className="calc-widget__options-holder"
      data-currency-holder={componentName}
    >
      <div
        className="calc-widget__select"
        aria-expanded={isSelectVisible}
        role="button"
        tabIndex={0}
        onClick={toggleSelectVisibility}
        onKeyDown={(e) => e.key === 'Enter' && toggleSelectVisibility()}
        data-calculator-currency={componentName}
        data-value={selectedCurrency}
      >
        <p>{selectedCurrency}</p>
        <span className={`calc-widget__select-chevron ${isDarkMode ? 'is-dark-mode' : ''}`} />
      </div>
      {isSelectVisible && (
        <div
          className="calc-widget__options-list"
          onClick={toggleSelectVisibility}
        >
          {fixedCurrencyList.map((option) => (
            <SingleOption
              key={option}
              option={option}
              optionName={option}
              handleSetClickedOption={setSelectedCurrency}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CalculatorCurrencySelect
